// extracted by mini-css-extract-plugin
module.exports = {"faq":"faq-home-module--faq--CBJoT"};